import type { Ari } from '@atlassian/ari';

import type { AudioFeatureType } from './models/AudioFeature';

export enum CustomTone {
	PLAYFUL = 'playful',
	PROFESSIONAL = 'professional',
	CONVERSATIONAL = 'conversational',
	SURPRISE = 'surprise',
}

export enum CustomLength {
	SHORT = 'short',
	MEDIUM = 'medium',
	LONG = 'long',
}

export enum AudioFormat {
	PCM = 'pcm',
	MP3 = 'mp3',
	JSON = 'json',
}

export interface AudioRequest {
	ari: Ari;
	locale: string;
	type: AudioFeatureType;
	instructions?: {
		tone: CustomTone;
		length: CustomLength;
	};
	format: AudioFormat;
	activationId: string;
}

export const getAudio = async ({
	ari,
	locale,
	type,
	instructions,
	format,
	activationId,
}: AudioRequest) => {
	const response = await fetch('/gateway/api/v2/audio', {
		method: 'POST',
		body: JSON.stringify({
			resources: [
				{
					resource_ari: ari,
				},
			],
			locale,
			type,
			instructions,
			format,
		}),
		headers: {
			'Content-Type': 'application/json',
			'ATL-ActivationId': activationId,
		},
	});

	if (!response.body) {
		throw new Error('Response body is null');
	}

	return response.body;
};
